import * as React from 'react';
import { ActionLink, Body2, UIHeading5, Image } from '@cian/ui-kit';

import stars from './../../../../assets/starGrayMob.svg';
import * as styles from './styles.css';

export interface IFooterBlockProps {
  title: string;
  subtitle: string;
  actionText: string;
  onReportError?(): void;
}

export const FooterBlock = ({ title, subtitle, actionText, onReportError }: IFooterBlockProps): React.JSX.Element => {
  return (
    <div className={styles['footer-container']}>
      <div className={styles['icon-wrapper']}>
        <Image height={24} src={stars} width={24} />
      </div>
      <div className={styles['footer-text-wrapper']}>
        <UIHeading5 color="text-secondary-default">{title}</UIHeading5>
        <Body2 color="text-secondary-default">
          {subtitle}{' '}
          <ActionLink color="current_color" fontSize="S" inline onClick={onReportError} textDecoration="underline">
            {actionText}
          </ActionLink>
        </Body2>
      </div>
    </div>
  );
};
